<template>
  <div>
    <b-navbar  toggleable="lg"  :variant="header_color" fixed="top" class="navbar__header">
      <b-container style="width:1000px">

        <b-img @click="$router.push('/')" :src="require('../../assets/img/logo.png')" fluid right alt="logo" style="width:138px;height:47px"/>

        <b-navbar-toggle target="nav-collapse" @click="toggle"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto" :class="toggle_status ? 'hideMenu' : 'showMenu'" >

            <b-nav-item class="router_item" to="/" :class="$route.path == '/' ? 'nav_active' : ''">ホーム</b-nav-item>
            <b-nav-item class="router_item router_item_pc":class="$route.path == '/company_info' ? 'nav_active' : ''">
              <span @click="moreMenu('navListStatus')">会社概要</span>

              <ul class="subMenu" v-if="navListStatus">
                <li @click="changePage('/convert_page#dom1')">社長メッセージ</li>
                <li @click="changePage('/convert_page#dom2')">会社の未来像</li>
                <li @click="changePage('/convert_page#dom3')">会社沿革</li>
                <li @click="changePage('/convert_page#dom4')">経営理念</li>
                <li @click="changePage('/convert_page#dom5')">経営方針</li>

              </ul>
            </b-nav-item>
            <b-nav-item class="router_item router_item_mobil" to="/company_info" id="" :class="$route.path == '/company_info' ? 'nav_active' : ''">
              会社概要
            </b-nav-item>

            <b-nav-item class="router_item router_item_mobil" to="/enterprise" :class="$route.path == '/enterprise' ? 'nav_active' : ''">事業内容</b-nav-item>
            <b-nav-item class="router_item router_item_pc" :class="$route.path == '/enterprise' ? 'nav_active' : ''">
              <span @click="moreMenu2()">事業内容</span>
              <ul class="subMenu" v-if="navListStatus2">
                <li @click="changePage('/convert_page2#dom1')">事業内容</li>
                <li @click="changePage('/convert_page2#dom2')">事業理念</li>

              </ul>
            </b-nav-item>

            <b-nav-item class="router_item" to="/job_info" :class="$route.path == '/job_info' ? 'nav_active' : ''">採用情報</b-nav-item>
            <b-nav-item class="router_item" to="/cooperation" :class="$route.path == '/cooperation' ? 'nav_active' : ''">お問い合わせ</b-nav-item>
            <b-nav-item class="router_item" to="/company_duty" :class="$route.path == '/company_duty' ? 'nav_active' : ''">企業社会責任</b-nav-item>
            <!--<b-nav-item v-if="!token" :class="toggle_status ? 'login' : ''" to="/login">
              未登録<b-icon icon="person-fill"></b-icon>
            </b-nav-item>
            <b-nav-item v-else :class="toggle_status ? 'login' : ''" >
              <el-button style="background: rgba(0,0,0,0);padding: 0 10px;border-radius:0;border: none; color: #ffffff" :class="$route.path == '/my_resume' ? 'nav_active' : ''" @click="$router.push('/my_resume')">{{ this.usersname }}</el-button>
              <el-button style="background: rgba(0,0,0,0);padding: 5px
               10px;border: 1px solid #ffffff; color: #ffffff" @click="exitUser">退出</el-button>


            </b-nav-item>-->
          </b-navbar-nav>
        </b-collapse>
      </b-container>
      <div class="navbar__child" v-if="navListStatus">

      </div>
      <div class="navbar__child2" v-if="navListStatus2">

      </div>
    </b-navbar>

  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props:["background_color"],
  name: "navComponent",

  data(){
    return{
      header_color: "rgba(0,0,0,0.6)",
      menuChild: false,
      navListStatus: false,
      navListStatus2: false,
      toggle_status: true,
      usersname: "未登録",
      avatar:""
    }
  },
  mounted() {
    this.header_color = this.background_color;
    this.usersname = this.nickname
  },
  computed:{
   ...mapGetters([
      'nickname',
      'token'
    ]),
  },
  watch:{
    nickname(newVal){
      this.usersname = newVal
    }
  },

  methods:{
    moreMenu(){
      this.navListStatus2 = false
      this.navListStatus = !this.navListStatus
      var scrolltopTemp = document.documentElement.scrollTop || document.body.scrollTop
      if (scrolltopTemp > 355){
        this.menuChild = true
        this.header_color = "rgba(0,0,0,0.5)"
      }else{
        if (this.navListStatus){
          this.menuChild = true
          this.header_color = "rgba(0,0,0,0.5)"
          return
        }
        this.menuChild = false
        this.header_color = "rgba(0,0,0,0)"
      }
    },
    moreMenu2(){
      this.navListStatus = false
      this.navListStatus2 = !this.navListStatus2
      this.navListStatus3 = false
      var scrolltopTemp = document.documentElement.scrollTop || document.body.scrollTop
      if (scrolltopTemp > 355){
        this.menuChild = true
        this.header_color = "rgba(0,0,0,0.5)"
      }else{
        if (this.navListStatus2){
          this.menuChild = true
          this.header_color = "rgba(0,0,0,0.5)"
          return
        }
        this.menuChild = false
        this.header_color = "rgba(0,0,0,0)"
      }
    },

    toggle(e){
      let target = e.currentTarget.ariaExpanded
      if (target == 'false'){
        this.toggle_status = false;
        this.header_color = "white";
      }else{
        this.toggle_status = true;
        this.header_color = "rgba(0,0,0,0)";
      }

    },
    changePage(index){
      this.$set(this, "navListStatus", false)
      this.$set(this, "navListStatus2", false)
      this.$router.push(index)
    },
    exitUser(){
      this.$confirm('确定退出账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {

        this.$store.dispatch("app/exitUser").then((res)=>{
          if(res.data.code == 1){
            this.$message.success("退出成功")
          }
        })
      })
    }
  }
}
</script>

<style scoped >
.ml-auto{
  color: #ffffff;
}
.nav_active{
  border-bottom: 3px solid #0096ff!important;
}

/deep/ .showMenu .nav-link, /deep/.showMenu .navbar-light /deep/.showMenu .navbar-nav{
  font-size: 14px;
  color: #000000!important;
}
/deep/ .hideMenu .nav-link, /deep/.hideMenu .navbar-light /deep/.hideMenu .navbar-nav{
  font-size: 14px;
  color: #000000!important;
}
.login{
  margin-left: 30px;
}
@media (max-width: 992px) {
  .router_item_pc{
    display: none;
  }
  .router_item_mobil{
    display: block;
  }
}
@media (min-width: 992px) {
  #router_item_pc{
    display: block;
  }
  .router_item_mobil{
    display: none;
  }
}
.router_item{
  margin-right: 25px;
  position: relative;
}
:focus{
  outline: none;
}
.router2:focus{
  outline: none;
}
.navbar__header{
  width:100%;
  height: auto;
  background: #F2F2F2;
}
.navbar__child{
  width: 100%;
  height: 150px;
  position: absolute;
  bottom: -150px;
  left: 0;
  font-size: 12px;
  text-align: center;
  background: #ffffff;
}
.navbar__child li{
  margin-bottom: 10px;
}

.navbar__child2{
  width: 100%;
  height: 70px;
  position: absolute;
  bottom: -70px;
  left: 0;
  font-size: 12px;
  text-align: center;
  background: #ffffff;
}
.navbar__child2 li{
  margin-bottom: 10px;
}
a:-webkit-any-link:focus{
  outline-offset: 1px;
}
.showMenu a:hover{
  color: #000000;
}
.hideMenu a:hover{
  color: #ffffff;
}
.subMenu{
  width: 100%;
  position: absolute;
  left: 0;
  top:52px;
  white-space:nowrap;
  font-size: 12px;
  list-style: none;
  z-index: 99999999;
}
.subMenu>li{
  cursor: pointer;
  color: #000000;
  margin-top: 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/nav/nav_components.vue